__turbopack_context__.v({
  "background": "squareAd-module-scss-module__k48ATa__background",
  "button": "squareAd-module-scss-module__k48ATa__button",
  "container": "squareAd-module-scss-module__k48ATa__container",
  "content": "squareAd-module-scss-module__k48ATa__content",
  "desc": "squareAd-module-scss-module__k48ATa__desc",
  "title": "squareAd-module-scss-module__k48ATa__title",
});
